import { render, staticRenderFns } from "./LanguageTest.vue?vue&type=template&id=7fb87880&scoped=true"
import script from "./LanguageTest.vue?vue&type=script&lang=js"
export * from "./LanguageTest.vue?vue&type=script&lang=js"
import style0 from "./LanguageTest.vue?vue&type=style&index=0&id=7fb87880&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb87880",
  null
  
)

export default component.exports